export default [
  {
    path: "/supplierManagement",
    component: () => import("./supplierManagement.vue"),
    name: "supplierManagement",
    meta: {
      // title: '供应商管理',
      title: "Sidebar.wmssubsTitle[1]"
    }
  },
  {
    path: "/supplierClass",
    component: () => import("./supplierClass.vue"),
    name: "supplierClass",
    meta: {
      // title: '供应商分类管理'
      title: "Sidebar.wmssubsTitle[2]"
    }
  },
  {
    path: "/GoodsList",
    component: () => import("./GoodsList.vue"),
    name: "GoodsList",
    meta: {
      // title: '商品列表'
      title: "Sidebar.wmssubsTitle[3]"
    }
  },
  {
    path: "/BatchUpdateItemPrice",
    component: () => import("./BatchUpdateItemPrice.vue"),
    name: "BatchUpdateItemPrice",
    meta: {
      // title: '批量更新价格'
      title: "Sidebar.wmssubsTitle[9]"
    }
  },
  {
    path: "/GoodsOut",
    component: () => import("./GoodsOut.vue"),
    name: "GoodsOut",
    meta: {
      // title: '商品出库'
      title: "Sidebar.wmssubsTitle[6]"
    }
  },
  {
    path: "/GoodsIn",
    component: () => import("./GoodsIn.vue"),
    name: "GoodsIn",
    meta: {
      // title: '商品入库'
      title: "Sidebar.wmssubsTitle[7]"
    }
  },
  {
    path: "/subscribe",
    component: () => import("./subscribe.vue"),
    name: "subscribe",
    meta: {
      // title: '商品申购'
      title: "Sidebar.wmssubsTitle[4]"
    }
  },
  {
    path: "/purchase",
    component: () => import("./purchase.vue"),
    name: "purchase",
    meta: {
      // title: '商品采购'
      title: "Sidebar.wmssubsTitle[5]"
    }
  },
  {
    path: "/newpurchaseordere",
    component: () => import("./newpurchaseordere.vue"),
    name: "newpurchaseordere",
    meta: {
      // title: '商品采购'
      title: "Sidebar.wmssubsTitle[8]"
    }
  },
  {
    path: "/ProjectManagement",
    component: () => import("./ProjectManager.vue"),
    name: "ProjectManagement",
    meta: {
      // title: '商品采购'
      title: "Sidebar.wmssubsTitle[10]"
    }
  }
];



// WEBPACK FOOTER //
// ./src/components/page/Purchase/router.js